
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart } from "lucide-react";
import { ChartContainer, ChartTooltipContent } from "@/components/ui/chart";
import {
  BarChart as RechartsBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

interface ChitPoolChartProps {
  data: Array<{
    name: string;
    amount: number;
  }>;
}

const ChitPoolChart = ({ data }: ChitPoolChartProps) => {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg font-medium">
            Chit Pool Distribution
          </CardTitle>
          <BarChart className="h-4 w-4 text-muted-foreground" />
        </div>
      </CardHeader>
      <CardContent className="px-2">
        <div className="h-[300px]">
          {data.length > 0 ? (
            <ChartContainer 
              config={{ 
                amount: { label: "Amount" },
              }}
            >
              <RechartsBarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 60 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" angle={-45} textAnchor="end" height={70} />
                <YAxis />
                <Tooltip content={<ChartTooltipContent />} />
                <Legend />
                <Bar dataKey="amount" fill="#0088FE" name="Amount" />
              </RechartsBarChart>
            </ChartContainer>
          ) : (
            <div className="flex items-center justify-center h-full">
              <p className="text-muted-foreground">No chit pool data available</p>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default ChitPoolChart;
